<div class="pageheader">
  <div class="page-title">
    <h1>Export</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="srcView.clear(); refresh()">Refresh
        <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
    </div>
  </div>
</div>

<div class="grid-container">
  <div class="grid-header">
    <div>

      <app-layout-container fluid>
        <app-layout-row>
          <app-layout-column [width]="3" offset="0">
            <app-button secondary width="100%" [disabled]="!srcView.hasExportItems" (buttonClick)="srcView.clear()">Reset</app-button>
          </app-layout-column>
          <app-layout-column [width]="3" offset="0">
            <app-button primary width="100%" [disabled]="!srcView.hasExportItems" (buttonClick)="srcView.export()" *bizPermissionRequired="'Developer_Action_Export'">Export</app-button>
          </app-layout-column>
          <app-layout-column [width]="6" offset="0">
            <app-checkbox [disabled]="!hasIncludeArtifactsAdminPermission" caption="Include artifacts in export" [(ngModel)]="includeArtifacts"></app-checkbox>
          </app-layout-column>
        </app-layout-row>
      </app-layout-container>

    </div>
  </div>
  <div class="with-border">
      <app-developer-export-dbview #dbView [formatTypes]="formatTypes"
                                   [formats]="formats"
                                   [variants]="variants"
                                   [versions]="versions"
                                   [distros]="distros"
                                   [docConfigs]="docConfigs"
                                   [trackingFields]="trackingFields"
                                   [configKeys]="configKeys"
                                   [itinerarySteps]="itinerarySteps"
                                   [exceptions]="exceptions"
                                   [configKeyUsage]="configKeyUsage"
                                   [fileNamingTypes]="fileNamingTypes"
                                   [xmlArtifacts]="xmlArtifacts"
                                   [assemblyArtifacts]="assemblyArtifacts"
                                   [documentConfigItinerarySteps]="documentConfigItinerarySteps"
                                   [initializeSteps]="initializeSteps"
                                   [transportTypes]="transportTypes"
                                   [promotionFilters]="promotionFilters"
                                   [duplicateChecks]="duplicateChecks"
                                   [contentTypeGroups]="contentTypeGroups"
                                   [documentTypeClassifiers]="documentTypeClassifiers"
                                   [documentTypeClassifierResolvers]="documentTypeClassifierResolvers"
                                   [batchingConfigurations]="batchingConfigurations"
                                   [scheduleItems]="scheduleItems"
                                   [scheduleTriggers]="scheduleTriggers"
                                   [documentConfigOutBatchers]="documentConfigOutBatchers"
                                   [identificationTypes]="identificationTypes"
                                   [identificationTypeQualifiers]="identificationTypeQualifiers"
                                   [concurrencyKeys]="concurrencyKeys">
      </app-developer-export-dbview>
  </div>
  <div class="grid-buttons">
    <div>
      <button type="button" class="btn btn-default" [disabled]="!dbView.selectedNodeCount"
        (click)="srcView.addExportItems(dbView.getExportItems())">&gt;&gt;</button>
      <button type="button" class="btn btn-default" [disabled]="!srcView.selectedNodeCount"
        (click)="srcView.removeSelectedItems()">&lt;&lt;</button>
    </div>
  </div>
  <div class="with-border">
    <app-developer-export-source [includeArtifacts]="includeArtifacts" [dataMapper]="dbView" #srcView></app-developer-export-source>
  </div>
</div>
